{
  "nl": {
    "collections": {
      "headings": {
        "courses": "Passende nascholing",
        "gradeLevels": "Leerjaren",
        "materials": "Materialen",
        "schoolTypes": "Schooltypen",
        "subjectTypes": "Schoolvakken"
      },
      "howTo": {
        "header": {
          "heading": "De collecties - ontdek kant-en-klaar lesmateriaal",
          "link": "Alle collecties ontdekken",
          "list_html": "<li><i class='bi bi-check-lg'></i>Collecties zijn samengestelde verzamelingen van lesmateriaal over specifieke onderwerpen en voor specifieke doelgroepen.</li><li><i class='bi bi-check-lg'></i>Vind volledige lesontwerpen met al het materiaal, of kies afzonderlijke elementen en pas ze aan voor jouw doeleinden.</li><li><i class='bi bi-check-lg'></i>Met de remix-knop maak je in een handomdraai een eigen kopie in je eigen opslag en kun je deze direct in de les gebruiken.</li>"
        },
        "recommendations": {
          "heading": "Ontdek actuele collecties"
        },
        "tile": {
          "collectionTitle": "Vervangingslessen voor bewegend leren",
          "help": {
            "author_partner": "Auteur of partner",
            "title": "Onderwerp van de collectie"
          },
          "staticAlt": "Kinderen die buiten met een bal spelen"
        },
        "title": "Alles wat je moet weten over collecties"
      },
      "labels": {
        "fobizzTeam": "Het fobizz team"
      },
      "links": {
        "breadCrumbIndex": "Lesmateriaal",
        "email": "E-mail",
        "learnMore": "Meer informatie"
      },
      "modelName": "Collectie",
      "correctionAssistantHint": "AI kan docenten ondersteunen bij het analyseren van leerlingenwerk en het formuleren van feedback. De gegenereerde inhoud zijn suggesties die altijd gecontroleerd moeten worden. De pedagogische beoordeling wordt altijd door de docent gedaan. Meer informatie vind je <a href='https://app.fobizz.com/website/public_pages/63f40923-707c-4c29-a3fb-24190cbaccd4?public_token=5661a251e6152bb6cc51ff14facde3d4&back_url=https%3A%2F%2Fapp.fobizz.com%2Fcollections%2Fb7294bbe-a1df-4a10-9031-89fc64cd1766&back_title=Vorlagen%20f%C3%BCr%20Korrekturhilfe%20und%20SuS-Feedback%20Assistenten' target='_blank'>hier</a>.",
      "searchPlaceholder": "Materiaal zoeken",
      "share": {
        "email": {
          "body": "In de fobizz galerij heb ik \"{name}\" gevonden en wil het met je delen. Via de volgende link heb je er toegang toe: {shareUrl}"
        }
      }
    }
  }
}
